import React, { useState, useEffect } from 'react'
import {
  Button, Grid
} from '@material-ui/core'

import { handleAupParser } from '../../../../utils'

import { useQuill } from 'react-quilljs'
import 'quill/dist/quill.snow.css'

const modules = {
  toolbar: false
}

/**
 * Returns AUP view form
 */
const AUPview = ({
  theme, formats, placeholder, aupName,
  aupHtml, onBackTrack, classes
}) => {
  const [newAupName, setNewAupName] = useState('')

  const initAupQuill = useQuill({ theme, modules, formats, placeholder })
  const aupQuill = initAupQuill.quill
  const aupQuillRef = initAupQuill.quillRef

  useEffect(() => {
    if (aupHtml && aupQuill) {
      const aupQuillContent = handleAupParser(aupHtml)
      aupQuill.setContents(aupQuillContent)
      aupQuill.enable(false)
    }
  }, [aupQuill, aupHtml])

  useEffect(() => {
    if (aupName) {
      setNewAupName(aupName)
    }
  }, [aupName])

  return (
    <>
      <Button
        className={`${classes.greenBtn} mt-1 mb-4`}
        onClick={(e) => { e.preventDefault(); onBackTrack() }}
        variant='contained'
      >
        <span className='font-weight-bold'>Back</span>
      </Button>
      <Grid item container direction='row'>
        <Grid item container direction='column' sm={8}>
          <h1 className='mb-4'>
            {newAupName}
          </h1>
        </Grid>
        <Grid item container direction='column' sm={12}>
          <Grid item container direction='row' className='mt-4'>
            <Grid item container direction='column' sm={12}>
              <div className='mb-5' style={{ height: 300 }}>
                <div ref={aupQuillRef} />
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default AUPview
